module.exports = __webpack_public_path__ + "img/all.6abde52f.svg";